<template>
  <d-modal
    :class="{ 'is-hidden': isHidden }"
    @close="handleClose">
    <d-modal-header>
      <template v-if="editMode">Edycja adresu dostawy</template>
      <template v-else>Dodawanie adresu dostawy</template>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <d-container class="pl-0 pr-0">
          <validation-observer
            ref="client-delivery-address-form"
            tag="form">
            <d-row>
              <d-col
                lg="6"
                md="6">
                <div class="form-group">
                  <label for="name"> Nazwa firmy: </label>

                  <validation-provider
                    rules="required"
                    name="name"
                    v-slot="{ errors }">
                    <d-input
                      :state="errors.length ? 'invalid' : null"
                      v-model="name"/>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </div>
              </d-col>
              <d-col
                lg="6"
                md="6">
                <div class="form-group">
                  <label for="surname"> Imię i nazwisko: </label>

                  <validation-provider
                    rules=""
                    name="surname"
                    v-slot="{ errors }">
                    <d-input
                      :state="errors.length ? 'invalid' : null"
                      v-model="surname"/>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </div>
              </d-col>
            </d-row>
            <div class="form-group">
              <label for="street"> Ulica: </label>

              <validation-provider
                rules="required"
                name="street"
                v-slot="{ errors }">
                <d-input
                  :state="errors.length ? 'invalid' : null"
                  v-model="street"/>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
            <d-row>
              <d-col
                lg="6"
                md="6">
                <div class="form-group">
                  <label for="building_number"> Numer budynku: </label>

                  <validation-provider
                    rules=""
                    name="building_number"
                    v-slot="{ errors }">
                    <d-input
                      :state="errors.length ? 'invalid' : null"
                      v-model="building_number"/>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </div>
              </d-col>

              <d-col
                lg="6"
                md="6">
                <div class="form-group">
                  <label for="house_number"> Numer lokalu: </label>

                  <validation-provider
                    name="house_number"
                    v-slot="{ errors }">
                    <d-input
                      :state="errors.length ? 'invalid' : null"
                      v-model="house_number"
                    />
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </div>
              </d-col>
            </d-row>
            <d-row>
              <d-col
                lg="6"
                md="6">
                <div class="form-group">
                  <label for="city"> Miejscowość: </label>

                  <validation-provider
                    rules="required"
                    name="city"
                    v-slot="{ errors }">
                    <d-input
                      :state="errors.length ? 'invalid' : null"
                      v-model="city"/>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </div>
              </d-col>

              <d-col
                lg="6"
                md="6">
                <div class="form-group">
                  <label for="post_code"> Kod pocztowy: </label>

                  <validation-provider
                    rules="required"
                    name="post_code"
                    v-slot="{ errors }">
                    <d-input
                      :state="errors.length ? 'invalid' : null"
                      v-model="post_code"/>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </div>
              </d-col>
            </d-row>
          </validation-observer>
        </d-container>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel">
        Anuluj
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        :disabled="submitInProgress"
        @click.prevent="validateForm">
        <div
          v-if="submitInProgress"
          class="spinner-border spinner-border-sm"
          role="status"></div>
        <template v-if="editMode">Zapisz zmiany</template>
        <template v-else>Dodaj</template>
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'client-delivery-address-popup',
  data() {
    return {
      id: null,
      name: '',
      surname: '',
      street: '',
      building_number: '',
      house_number: '',
      post_code: '',
      city: '',
      isHidden: true,
      submitInProgress: false,
      referrerID: null,
      editMode: false,
    };
  },
  mounted() {
    this.$bus.$on('client-delivery-address-popup-show', this.openPopup);
  },
  methods: {
    handleClose() {
      this.isHidden = true;
    },
    validateForm() {
      FormUtils.validate(this.$refs['client-delivery-address-form'], this.save);
    },
    save() {
      this.submitInProgress = true;

      let params = {
        name: this.name,
        surname: this.surname,
        street: this.street,
        building_number: this.building_number,
        house_number: this.house_number,
        post_code: this.post_code,
        city: this.city,
        customer_id: this.referrerID,
      };

      let endpointUrl = '/api/contacts/addresses/store';

      if (this.editMode) {
        endpointUrl = '/api/contacts/addresses/update/' + this.id;
      }

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: params,
        successTitle: 'Zapisano adres',
        successText: 'Wybrany adres został zapisany',
        errorTitle: 'Wystąpił błąd',
        errorText:
          'Modyfikacja danych adres nie powiodła się. Spróbuj ponownie.',
        successAction: (response) => {
          this.submitInProgress = false;
          this.$bus.$emit('client-delivery-address-added', this.referrerID, response.item.id);
          this.handleClose();
        },
        failAction: () => {
          this.submitInProgress = false;
        },
      });
    },
    openPopup(clientId, addressData = false) {
      this.referrerID = clientId;
      this.editMode = !!addressData;

      if (this.editMode) {
        this.id = addressData.id;
        this.name = addressData.name;
        this.surname = addressData.surname;
        this.street = addressData.street;
        this.building_number = addressData.building_number;
        this.house_number = addressData.house_number;
        this.post_code = addressData.post_code;
        this.city = addressData.city;
      } else {
        this.id = null;
        this.name = '';
        this.surname = '';
        this.street = '';
        this.building_number = '';
        this.house_number = '';
        this.post_code = '';
        this.city = '';
      }

      setTimeout(() => {
        this.isHidden = false;
        if (this.$refs['client-delivery-address-form']) {
          this.$refs['client-delivery-address-form'].reset();
        }
      }, 0);
    },
    cancel() {
      this.handleClose();
    },
  },
};
</script>

<style lang="scss" scoped>
.modal.is-hidden {
  display: none;
  pointer-events: none;
}
</style>
